import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const summariseAssets = api(({ summarise, filters, regimeId, group, search, sort }) =>
    query(
        gql`
            query SummariseAssets(
                $regimeId: String!
                $group: String
                $search: String
                $sort: [String]
                $summarise: [String!]!
                $filters: [JSONObject]
            ) {
                regimeAssetSummary(
                    regimeId: $regimeId
                    group: $group
                    sort: $sort
                    search: $search
                    filters: $filters
                ) {
                    summarise(by: $summarise) {
                        summary(take: 10000) {
                            key
                            value
                            count
                            minutes
                        }
                    }
                    id
                }
            }
        `,
        {
            summarise,
            regimeId,
            group,
            sort,
            search,
            filters,
        },
        { returns: "regimeAssetSummary.summarise.summary" }
    )
)
